import React, { useState } from 'react';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(targetId);
    if (el) {
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 72,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <nav className="nav-glass">
        <div className="nav-inner">
          <a href="#top" className="nav-logo" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <div className="nav-logo-icon">
              <i className="fa-solid fa-cube"></i>
            </div>
            <span className="nav-logo-text">square<span className="accent">prod</span></span>
          </a>

          <div className="nav-links">
            <a href="#services" className="nav-link" onClick={(e) => handleNavClick(e, '#services')}>Services</a>
            <a href="#work" className="nav-link" onClick={(e) => handleNavClick(e, '#work')}>Work</a>
            <a href="#about" className="nav-link" onClick={(e) => handleNavClick(e, '#about')}>About</a>
            <a href="#process" className="nav-link" onClick={(e) => handleNavClick(e, '#process')}>Process</a>
            <a href="#contact" className="nav-link" onClick={(e) => handleNavClick(e, '#contact')}>Contact</a>
          </div>

          <div className="nav-actions">
            <a href="#contact" className="btn-ember nav-cta" onClick={(e) => handleNavClick(e, '#contact')}>Start a Project</a>
            <button className="menu-btn" onClick={() => setMenuOpen(true)}>
              <i className="fa-solid fa-bars"></i>
            </button>
          </div>
        </div>
      </nav>

      <div className={`mob-menu ${menuOpen ? 'show' : ''}`}>
        <button className="mob-menu-close" onClick={() => setMenuOpen(false)}>
          <i className="fa-solid fa-xmark"></i>
        </button>
        <a href="#services" onClick={(e) => handleNavClick(e, '#services')}>Services</a>
        <a href="#work" onClick={(e) => handleNavClick(e, '#work')}>Work</a>
        <a href="#about" onClick={(e) => handleNavClick(e, '#about')}>About</a>
        <a href="#process" onClick={(e) => handleNavClick(e, '#process')}>Process</a>
        <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>Contact</a>
        <a href="#contact" className="btn-ember" style={{ marginTop: '1rem', fontSize: '1rem', padding: '0.75rem 2rem' }} onClick={(e) => handleNavClick(e, '#contact')}>Start a Project</a>
      </div>
    </>
  );
}

export default Navbar;
